"use strict";
exports.__esModule = true;
exports.TransactionTypeCode = void 0;
/*
 * TransactionTypeCode is the controlling enum .. every transaction must have an entry
 * in here - which is also required in the TransactionCodeDictionary where its
 * processing attributes are defined.  Make sure you make an entry in both places.
 * By convention - please just add new codes at the bottom - we don't want to
 * convert to alphabetic order here ... so adding at the bottom will make it easy
 * to see when transaction codes were added.
 */
var TransactionTypeCode;
(function (TransactionTypeCode) {
    TransactionTypeCode["InvestingContribution"] = "InvestingContribution";
    TransactionTypeCode["DividendReinvestment"] = "DividendReinvestment";
    TransactionTypeCode["STCapitalGainReinvestment"] = "STCapitalGainReinvestment";
    TransactionTypeCode["LTCapitalGainReinvestment"] = "LTCapitalGainReinvestment";
    TransactionTypeCode["RebalanceBuy"] = "RebalanceBuy";
    TransactionTypeCode["InvestmentProgramUpdateBuy"] = "InvestmentProgramUpdateBuy";
    TransactionTypeCode["AdjustmentBuy"] = "AdjustmentBuy";
    TransactionTypeCode["Deposit"] = "Deposit";
    TransactionTypeCode["EmployeeDeferral"] = "EmployeeDeferral";
    TransactionTypeCode["EmployerContribution"] = "EmployerContribution";
    TransactionTypeCode["QNEC"] = "QNEC";
    TransactionTypeCode["QMAC"] = "QMAC";
    TransactionTypeCode["LoanPayment"] = "LoanPayment";
    TransactionTypeCode["RolloverDeposit"] = "RolloverDeposit";
    TransactionTypeCode["CashConversionDeposit"] = "CashConversionDeposit";
    TransactionTypeCode["AdjustmentDeposit"] = "AdjustmentDeposit";
    TransactionTypeCode["ActivityFee"] = "ActivityFee";
    TransactionTypeCode["LoanFee"] = "LoanFee";
    TransactionTypeCode["DistributionFee"] = "DistributionFee";
    TransactionTypeCode["AssetFee"] = "AssetFee";
    TransactionTypeCode["AdministrativeFee"] = "AdministrativeFee";
    TransactionTypeCode["AdvisorFee"] = "AdvisorFee";
    TransactionTypeCode["GeneralFee"] = "GeneralFee";
    TransactionTypeCode["FeeAdjustment"] = "FeeAdjustment";
    TransactionTypeCode["Dividend"] = "Dividend";
    TransactionTypeCode["CapitalGainLT"] = "CapitalGainLT";
    TransactionTypeCode["CapitalGainST"] = "CapitalGainST";
    TransactionTypeCode["CashEquivalentInterest"] = "CashEquivalentInterest";
    TransactionTypeCode["LostInvestmentGainDeposit"] = "LostInvestmentGainDeposit";
    TransactionTypeCode["IncomeMisc"] = "IncomeMisc";
    TransactionTypeCode["DividendAdjustment"] = "DividendAdjustment";
    TransactionTypeCode["DividendReinvestmentAdjustment"] = "DividendReinvestmentAdjustment";
    TransactionTypeCode["CashEquivalentInterestAdjustment"] = "CashEquivalentInterestAdjustment";
    TransactionTypeCode["LostInvestmentGainWithdrawal"] = "LostInvestmentGainWithdrawal";
    TransactionTypeCode["IncomeMiscAdjustment"] = "IncomeMiscAdjustment";
    TransactionTypeCode["CapitalGainLTAdjustment"] = "CapitalGainLTAdjustment";
    TransactionTypeCode["CapitalGainLTAdjustmentReinvestment"] = "CapitalGainLTAdjustmentReinvestment";
    TransactionTypeCode["CapitalGainSTAdjustment"] = "CapitalGainSTAdjustment";
    TransactionTypeCode["CapitalGainSTAdjustmentReinvestment"] = "CapitalGainSTAdjustmentReinvestment";
    TransactionTypeCode["SellforDistribution"] = "SellforDistribution";
    TransactionTypeCode["SellforFees"] = "SellforFees";
    TransactionTypeCode["RebalanceSell"] = "RebalanceSell";
    TransactionTypeCode["InvestmentProgramUpdateSell"] = "InvestmentProgramUpdateSell";
    TransactionTypeCode["AdjustmentSell"] = "AdjustmentSell";
    TransactionTypeCode["ConversionTransferIn"] = "ConversionTransferIn";
    TransactionTypeCode["AdjustmentTransferIn"] = "AdjustmentTransferIn";
    TransactionTypeCode["ConversionTransferOut"] = "ConversionTransferOut";
    TransactionTypeCode["AdjustmentTransferOut"] = "AdjustmentTransferOut";
    TransactionTypeCode["TerminationDistribution"] = "TerminationDistribution";
    TransactionTypeCode["HardshipDistribution"] = "HardshipDistribution";
    TransactionTypeCode["InServiceDistribution"] = "InServiceDistribution";
    TransactionTypeCode["RequiredMinimumDistribution"] = "RequiredMinimumDistribution";
    TransactionTypeCode["Forfeiture"] = "Forfeiture";
    TransactionTypeCode["LoanWithdrawal"] = "LoanWithdrawal";
    TransactionTypeCode["RolloverWithdrawal"] = "RolloverWithdrawal";
    TransactionTypeCode["AdjustmentWithdrawal"] = "AdjustmentWithdrawal";
    TransactionTypeCode["Withdrawal"] = "Withdrawal";
    TransactionTypeCode["WithdrawalToAnotherAccount"] = "WithdrawalToAnotherAccount";
    TransactionTypeCode["WithdrawalToPlanLostGains"] = "WithdrawalToPlanLostGains";
    TransactionTypeCode["CashConversionWithdrawal"] = "CashConversionWithdrawal";
    TransactionTypeCode["CorrectiveWithdrawal"] = "CorrectiveWithdrawal";
    TransactionTypeCode["CorrectiveSell"] = "CorrectiveSell";
    TransactionTypeCode["Buy"] = "Buy";
    TransactionTypeCode["Sell"] = "Sell";
    TransactionTypeCode["SellForLoan"] = "SellForLoan";
    TransactionTypeCode["IntraPlanCashJournalInDistribution"] = "IntraPlanCashJournalInDistribution";
    TransactionTypeCode["IntraPlanCashJournalInFee"] = "IntraPlanCashJournalInFee";
    TransactionTypeCode["IntraPlanCashJournalInForfeiture"] = "IntraPlanCashJournalInForfeiture";
    TransactionTypeCode["IntraPlanCashJournalInSpendingBudget"] = "IntraPlanCashJournalInSpendingBudget";
    TransactionTypeCode["IntraPlanCashJournalInError"] = "IntraPlanCashJournalInError";
    TransactionTypeCode["IntraPlanCashJournalInBreakage"] = "IntraPlanCashJournalInBreakage";
    TransactionTypeCode["IntraPlanCashJournalInBilling"] = "IntraPlanCashJournalInBilling";
    TransactionTypeCode["IntraPlanCashJournalInDividend"] = "IntraPlanCashJournalInDividend";
    TransactionTypeCode["IntraPlanCashJournalInMoneyOut"] = "IntraPlanCashJournalInMoneyOut";
    TransactionTypeCode["IntraPlanCashJournalInMoneyIn"] = "IntraPlanCashJournalInMoneyIn";
    TransactionTypeCode["IntraPlanCashJournalInSuspense"] = "IntraPlanCashJournalInSuspense";
    TransactionTypeCode["IntraPlanCashJournalOutContribution"] = "IntraPlanCashJournalOutContribution";
    TransactionTypeCode["IntraPlanCashJournalOutRollover"] = "IntraPlanCashJournalOutRollover";
    TransactionTypeCode["IntraPlanCashJournalOutConversion"] = "IntraPlanCashJournalOutConversion";
    TransactionTypeCode["IntraPlanCashJournalOutForfeiture"] = "IntraPlanCashJournalOutForfeiture";
    TransactionTypeCode["IntraPlanCashJournalOutSpendingBudget"] = "IntraPlanCashJournalOutSpendingBudget";
    TransactionTypeCode["IntraPlanCashJournalOutError"] = "IntraPlanCashJournalOutError";
    TransactionTypeCode["IntraPlanCashJournalOutSuspense"] = "IntraPlanCashJournalOutSuspense";
    TransactionTypeCode["InvestingRollover"] = "InvestingRollover";
    TransactionTypeCode["InvestingConversion"] = "InvestingConversion";
    // Both As-of and Reversal Offset Transaction Type Codes
    TransactionTypeCode["OffsetSell"] = "OffsetSell";
    TransactionTypeCode["OffsetBuy"] = "OffsetBuy";
    // As-Of Offset Transaction Type Code
    TransactionTypeCode["OffsetDividendAdj"] = "OffsetDividendAdj";
    TransactionTypeCode["OffsetDividendReinvestAdj"] = "OffsetDividendReinvestAdj";
    TransactionTypeCode["OffsetCapitalGainLTAdj"] = "OffsetCapitalGainLTAdj";
    TransactionTypeCode["OffsetLTCapitalGainReinvestAdj"] = "OffsetLTCapitalGainReinvestAdj";
    TransactionTypeCode["OffsetCapitalGainSTAdj"] = "OffsetCapitalGainSTAdj";
    TransactionTypeCode["OffsetSTCapitalGainReinvestAdj"] = "OffsetSTCapitalGainReinvestAdj";
    TransactionTypeCode["OffsetWithdrawal"] = "OffsetWithdrawal";
    // Reversal Offset Transaction Type Codes
    TransactionTypeCode["OffsetDividend"] = "OffsetDividend";
    TransactionTypeCode["OffsetDividendReinvest"] = "OffsetDividendReinvest";
    TransactionTypeCode["OffsetCapitalGainLT"] = "OffsetCapitalGainLT";
    TransactionTypeCode["OffsetLTCapitalGainReinvest"] = "OffsetLTCapitalGainReinvest";
    TransactionTypeCode["OffsetCapitalGainST"] = "OffsetCapitalGainST";
    TransactionTypeCode["OffsetSTCapitalGainReinvest"] = "OffsetSTCapitalGainReinvest";
    TransactionTypeCode["OffsetDeposit"] = "OffsetDeposit";
    TransactionTypeCode["OffsetTransferIn"] = "OffsetTransferIn";
    TransactionTypeCode["OffsetTransferOut"] = "OffsetTransferOut";
    TransactionTypeCode["OffsetFee"] = "OffsetFee";
    TransactionTypeCode["OffsetFeeAdj"] = "OffsetFeeAdj";
    TransactionTypeCode["Overpayment"] = "Overpayment";
    TransactionTypeCode["MigrationTransferIn"] = "MigrationTransferIn";
    TransactionTypeCode["MigrationDeposit"] = "MigrationDeposit";
    TransactionTypeCode["PlanFeeCredit"] = "PlanFeeCredit";
    TransactionTypeCode["UnclassifiedDeposit"] = "UnclassifiedDeposit";
    TransactionTypeCode["ACHReversal"] = "ACHReversal";
    TransactionTypeCode["402gDistribution"] = "402gDistribution";
    TransactionTypeCode["QACADistribution"] = "QACADistribution";
    TransactionTypeCode["EACADistribution"] = "EACADistribution";
    TransactionTypeCode["DeathDistribution"] = "DeathDistribution";
    TransactionTypeCode["QDRODistribution"] = "QDRODistribution";
    TransactionTypeCode["ADPCorrectiveDistribution"] = "ADPCorrectiveDistribution";
    TransactionTypeCode["ACPCorrectiveDistribution"] = "ACPCorrectiveDistribution";
    TransactionTypeCode["415Distribution"] = "415Distribution";
    TransactionTypeCode["ACHDepositReversal"] = "ACHDepositReversal";
    TransactionTypeCode["PlanDeconversionWithdrawal"] = "PlanDeconversionWithdrawal";
    TransactionTypeCode["PlanTerminationWithdrawal"] = "PlanTerminationWithdrawal";
    TransactionTypeCode["PayrollContribution"] = "PayrollContribution";
    TransactionTypeCode["ProfitSharingContribution"] = "ProfitSharingContribution";
    TransactionTypeCode["SafeHarborContribution"] = "SafeHarborContribution";
    TransactionTypeCode["IntraPlanCashJournalInPlanLiquidation"] = "IntraPlanCashJournalInPlanLiquidation";
    TransactionTypeCode["CheckReversal"] = "CheckReversal";
    TransactionTypeCode["WireReversal"] = "WireReversal";
    TransactionTypeCode["ACHDistributionReversal"] = "ACHDistributionReversal";
    TransactionTypeCode["SellForPlanDeconversion"] = "SellForPlanDeconversion";
    TransactionTypeCode["SellForPlanTermination"] = "SellForPlanTermination";
    TransactionTypeCode["SuspenseCashJournalOut"] = "SuspenseCashJournalOut";
    TransactionTypeCode["ACHReversalRetry"] = "ACHReversalRetry";
    TransactionTypeCode["DistributionToSafeHarborIRA"] = "DistributionToSafeHarborIRA";
    TransactionTypeCode["CashOutDistribution"] = "CashOutDistribution";
    TransactionTypeCode["StoppedCheckDeposit"] = "StoppedCheckDeposit";
    TransactionTypeCode["ReturnedCheckDeposit"] = "ReturnedCheckDeposit";
    TransactionTypeCode["ReissuedCheckWithdrawal"] = "ReissuedCheckWithdrawal";
    TransactionTypeCode["ReissuedACHWithdrawal"] = "ReissuedACHWithdrawal";
    TransactionTypeCode["ReissuedWireWithdrawal"] = "ReissuedWireWithdrawal";
    TransactionTypeCode["ParticipantFee"] = "ParticipantFee";
    TransactionTypeCode["ManagedAccountFee"] = "ManagedAccountFee";
    TransactionTypeCode["CorrectionTransferOut"] = "CorrectionTransferOut";
    TransactionTypeCode["FeeRefund"] = "FeeRefund";
    TransactionTypeCode["DepositFromPlanLostGains"] = "DepositFromPlanLostGains";
    TransactionTypeCode["WithdrawalForFeeRefund"] = "WithdrawalForFeeRefund";
    TransactionTypeCode["FundMergerTransferIn"] = "FundMergerTransferIn";
    TransactionTypeCode["FundMergerTransferOut"] = "FundMergerTransferOut";
    TransactionTypeCode["CheckDepositReversal"] = "CheckDepositReversal";
    TransactionTypeCode["MarketValueAdjWithdrawal"] = "MarketValueAdjWithdrawal";
    TransactionTypeCode["OverpaymentWithdrawal"] = "OverpaymentWithdrawal";
    TransactionTypeCode["DistributionReversal"] = "DistributionReversal";
    TransactionTypeCode["QDROContribution"] = "QDROContribution";
    TransactionTypeCode["EmployerMatch"] = "EmployerMatch";
    TransactionTypeCode["InitialDepositBonus"] = "InitialDepositBonus";
    TransactionTypeCode["MilestoneBonus"] = "MilestoneBonus";
    TransactionTypeCode["Interest"] = "Interest";
    TransactionTypeCode["InterestAdjustment"] = "InterestAdjustment";
    TransactionTypeCode["OffsetInterest"] = "OffsetInterest";
    TransactionTypeCode["OffsetInterestAdj"] = "OffsetInterestAdj";
    TransactionTypeCode["LoanInterestPayment"] = "LoanInterestPayment";
    TransactionTypeCode["LoanPrincipalPayment"] = "LoanPrincipalPayment";
    TransactionTypeCode["InterestAllocationJournalOut"] = "InterestAllocationJournalOut";
    TransactionTypeCode["SDBACashJournalIn"] = "SDBACashJournalIn";
    TransactionTypeCode["SDBACashJournalOut"] = "SDBACashJournalOut";
    TransactionTypeCode["WithdrawalForStudentLoanPayment"] = "WithdrawalForStudentLoanPayment";
    TransactionTypeCode["WithdrawalFor529Contribution"] = "WithdrawalFor529Contribution";
    TransactionTypeCode["WithdrawalForESAPayment"] = "WithdrawalForESAPayment";
    TransactionTypeCode["UnclassifiedWithdrawal"] = "UnclassifiedWithdrawal";
    TransactionTypeCode["OutstandingCheckDeposit"] = "OutstandingCheckDeposit";
    TransactionTypeCode["ResidualDistributionFee"] = "ResidualDistributionFee";
    TransactionTypeCode["ResidualDistribution"] = "ResidualDistribution";
    TransactionTypeCode["ESAWithdrawal"] = "ESAWithdrawal";
    TransactionTypeCode["SaverDeposit"] = "SaverDeposit";
    TransactionTypeCode["PaperMailingFee"] = "PaperMailingFee";
    TransactionTypeCode["InvestingLoanRepayment"] = "InvestingLoanRepayment";
    TransactionTypeCode["SDBAMarketValueGain"] = "SDBAMarketValueGain";
    TransactionTypeCode["SDBAMarketValueLoss"] = "SDBAMarketValueLoss";
    TransactionTypeCode["ReturnedContributionWithdrawal"] = "ReturnedContributionWithdrawal";
    TransactionTypeCode["InvestingForFeeRefund"] = "InvestingForFeeRefund";
    TransactionTypeCode["SDBATransferBuy"] = "SDBATransferBuy";
    TransactionTypeCode["SDBATransferSell"] = "SDBATransferSell";
    TransactionTypeCode["InvestingSaverContribution"] = "InvestingSaverContribution";
    TransactionTypeCode["InvestingEmployerContribution"] = "InvestingEmployerContribution";
    TransactionTypeCode["InvestingLostGain"] = "InvestingLostGain";
    TransactionTypeCode["LostGainSell"] = "LostGainSell";
    TransactionTypeCode["ACHSetupFee"] = "ACHSetupFee";
    TransactionTypeCode["DeminimusResidualDeconversionFee"] = "DeminimusResidualDeconversionFee";
    TransactionTypeCode["InvestingQDROContribution"] = "InvestingQDROContribution";
    TransactionTypeCode["SellforQDRODistribution"] = "SellforQDRODistribution";
    TransactionTypeCode["QDROFee"] = "QDROFee";
    TransactionTypeCode["ExcessiveContributionAdjustment"] = "ExcessiveContributionAdjustment";
    TransactionTypeCode["CorrectiveAdjustment"] = "CorrectiveAdjustment";
    TransactionTypeCode["DividendTransferIn"] = "DividendTransferIn";
    TransactionTypeCode["DividendTransferOut"] = "DividendTransferOut";
    TransactionTypeCode["MarketValueGainTransferIn"] = "MarketValueGainTransferIn";
    TransactionTypeCode["MarketValueLossTransferOut"] = "MarketValueLossTransferOut";
    TransactionTypeCode["FeeTransferIn"] = "FeeTransferIn";
    TransactionTypeCode["FeeTransferOut"] = "FeeTransferOut";
})(TransactionTypeCode = exports.TransactionTypeCode || (exports.TransactionTypeCode = {}));
// NOTE : Please add new codes to end of list so we can easily see when they were added
